export default __webpack_public_path__ + "static/media/ta.883784af.jpg";